const ENDPOINT = "https://utm-emart-translation-system.onrender.com/translate" // or your deployed URL

export async function translate(text: string, targetLang: string): Promise<string> {
  // Don't translate if text is empty or target language is same as likely source
  if (!text || !text.trim()) {
    return text;
  }

  try {
    console.log(`🔄 Translating: "${text}" to ${targetLang}`);
    
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000); // 15 second timeout

    const res = await fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ q: text, target: targetLang }),
      signal: controller.signal
    });

    clearTimeout(timeoutId);

    console.log("🔤 Translation API response status:", res.status);

    if (!res.ok) {
      console.error("❌ Translation API error status:", res.status);
      const errorText = await res.text();
      console.error("❌ Error response:", errorText);
      return text; // fallback to original
    }

    const data = await res.json();
    console.log("🔤 Translation API response data:", data);

    if (!data.translatedText) {
      console.warn("⚠️ 'translatedText' not found in response");
      return text; // fallback to original
    }

    // If translation is identical to original, just return original
    if (data.translatedText === text) {
      console.log("💡 Translation identical to original, likely same language");
      return text;
    }

    console.log("✅ Translation successful:", data.translatedText);
    return data.translatedText;
    
  } catch (error: any) {
    if (error.name === 'AbortError') {
      console.error("❌ Translation request timed out");
    } else {
      console.error("❌ Error calling translation API:", error);
    }
    return text; // fallback to original
  }
}